// Local libary
import { FundingFacade } from '@amwager/funding/data-access';
import { UnsubscribeObservableService } from '@amwager/util';

// Angular libray
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertController } from '@ionic/angular/standalone';

// Third party
import { Subscription, takeUntil } from 'rxjs';
import { forEach } from 'lodash';
import { CommonModule } from '@angular/common';
import { CommonFacade } from '@amwager/data-access';

@Component({
  selector: 'feature-ion-money-pak',
  templateUrl: './money-pak.component.html',
  styleUrls: ['./money-pak.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MoneyPakComponent extends UnsubscribeObservableService implements OnInit {

  moneyPakForm!: FormGroup;

  // convenience getter for easy access to form fields
  get formVal() { return this.moneyPakForm?.controls }

  moneyPakNumber!: string;

  private subsDepositMoneyPakResponse!: Subscription;

  isDepositing = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly fundingFacade: FundingFacade,
    private readonly alertCtrl: AlertController,
    private readonly cdRef: ChangeDetectorRef,
    private readonly commonFacade: CommonFacade,
  ) {
    super();
  }

  ngOnInit() {
    // update branch 2
    this.initForm();
    this.formVal['moneyPakNumber']?.setValue('');
    this.moneyPakNumber = '';
  }

  private initForm(): void {
    this.moneyPakForm = this.formBuilder.group({
      moneyPakNumber: [
        '', [Validators.required]
      ]
    });
  }

  depositAmount(): void {
    this.moneyPakNumber = this.formVal['moneyPakNumber']?.value;
  }

  deposit(): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('MoneyPakComponent:deposit', false);
      return;
    }

    if (this.moneyPakForm.valid && this.moneyPakNumber) {
      this.isDepositing = true;

      this.fundingFacade.depositMoneyPak(
        this.moneyPakNumber,
      );
      this.subsDepositMoneyPakResponse = this.fundingFacade.isDepositMoneyPakSuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {
        // console.log(response);
        // console.log(isSuccess);
        if (!isSuccess && response !== undefined) {
          const errMsg = response?.Message ? response.Message : 'Invalid Moneypak Number';
          this.showAlertMessage('Deposit Error', errMsg);
          this.isDepositing = false;
          this.cdRef.markForCheck();
        }

        this.subsDepositMoneyPakResponse?.unsubscribe();

        if (isSuccess) {
          this.showAlertMessage('Successful Deposit', 'Successfully Deposited Amount');
          this.moneyPakForm.reset();
          this.isDepositing = false;
          this.cdRef.markForCheck();
        }
      });
    }
    else {
      this.markFormGroupTouched(this.moneyPakForm);
    }
  }

  markFormGroupTouched(formGroup: FormGroup): void {
    forEach(formGroup.controls, (control) => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  async showAlertMessage(header: string, message: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header,
      message: message,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }

}
